import { useState, useCallback } from 'preact/hooks';
import { api, type PoolResponse } from '../services/api.js';

export function usePool() {
  const [pool, setPool] = useState<PoolResponse | null>(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const data = await api.getPool();
      setPool(data);
    } catch (err) {
      console.error('Pool fetch error:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  return { pool, loading, refresh };
}
